import { render, staticRenderFns } from "./AlertesCommercialesTable.vue?vue&type=template&id=abfd41d8"
import script from "./AlertesCommercialesTable.vue?vue&type=script&lang=js"
export * from "./AlertesCommercialesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports